import { Loader2 } from "lucide-react";

export function EmptyState({ icon: Icon, title, description, action, testId }) {
  return (
    <div
      data-testid={testId || "empty-state"}
      className="flex flex-col items-center justify-center rounded-xl border border-dashed border-border bg-card py-16 px-6 text-center"
    >
      {Icon && (
        <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-brand-tertiary text-brand">
          <Icon className="h-7 w-7" />
        </div>
      )}
      <h3 className="font-display text-xl font-bold uppercase tracking-wide text-midnight">{title}</h3>
      {description && <p className="mt-1 max-w-sm text-sm text-muted-foreground">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

export function Loading({ label = "Loading…", testId }) {
  return (
    <div data-testid={testId || "loading"} className="flex items-center justify-center gap-2 py-20 text-muted-foreground">
      <Loader2 className="h-5 w-5 animate-spin" />
      <span className="text-sm">{label}</span>
    </div>
  );
}

export function ErrorState({ message, onRetry }) {
  return (
    <div className="rounded-xl border border-danger/30 bg-danger-bg p-6 text-center">
      <p className="text-sm font-semibold text-danger">{message || "Something went wrong"}</p>
      {onRetry && (
        <button
          onClick={onRetry}
          data-testid="error-retry-btn"
          className="mt-3 rounded-md bg-danger px-4 py-2 text-sm font-bold text-white"
        >
          Retry
        </button>
      )}
    </div>
  );
}
